module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.drawerMode && _vm.groupEditor) ? _c('p', {
    staticClass: "selectSeat",
    staticStyle: {
      "color": "red",
      "font-style": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exams.classrooms.groupEditorTurnedOn')))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "classroom_name"
  }, [_vm._v(_vm._s(this.classroomStructure.name) + " \n    "), _c('button', {
    staticClass: "seatMarksButton",
    class: {
      'activeProperty': _vm.showSeatMarks
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSeatMarks()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]), _vm._v(" "), (_vm.drawerMode) ? _c('button', {
    staticClass: "seatMarksButton",
    class: {
      'activeProperty': _vm.showExerciseGroups
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleExecGroups()
      }
    }
  }, [_c('i', {
    staticClass: "fa"
  }, [_vm._v("♛")])]) : _vm._e(), _vm._v(" "), (_vm.drawerOnly) ? _c('button', {
    staticClass: "seatMarksButton",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.increaseSize()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.drawerOnly) ? _c('button', {
    staticClass: "seatMarksButton",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.decreaseSize()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]) : _vm._e(), _vm._v(" "), (_vm.drawerOnly) ? _c('button', {
    staticClass: "seatMarksButton",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetSize()
      }
    }
  }, [_c('i', {
    staticClass: "fa"
  }, [_vm._v("↺")])]) : _vm._e()]), _vm._v(" "), (!_vm.drawerMode) ? _c('p', {
    staticClass: "selectSeat"
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exams.editExam.selectSeat')))]) : _vm._e(), _vm._v(" "), (_vm.drawerMode && _vm.customColoring) ? _c('p', {
    staticClass: "selectSeat"
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exams.classrooms.selectColorSeats')))]) : _vm._e(), _vm._v(" "), _c('table', {
    attrs: {
      "id": "classroom_preview"
    }
  }, [(!_vm.drawerMode) ? _c('tr', {
    attrs: {
      "id": "classroom-struct"
    }
  }, _vm._l((_vm.classroomStructure.data), function(wing) {
    return _c('td', {
      key: wing.id,
      staticClass: "classroom-wing",
      class: {
        "classroom-wing-left-side": (wing.id === 0)
      }
    }, _vm._l((wing), function(row) {
      return _c('tr', {
        key: row.id,
        staticClass: "classroom-row"
      }, [(row[0].id.split('_')[0] === '0' && _vm.showSeatMarks) ? _c('div', {
        staticClass: "rowMark"
      }, [_vm._v(" " + _vm._s(Number(row[0].id.split('_')[1])) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((row), function(seat) {
        return _c('td', {
          key: seat.id
        }, [_c('button', {
          staticClass: "seatButton",
          on: {
            "click": function($event) {
              return _vm.assignSeat(seat.id, seat.exerciseGroup)
            }
          }
        }, [_c('div', {
          class: {
            "classroom-seat": ((!_vm.drawerMode) && (!seat.assigned)), "seat-drawer": _vm.drawerMode, "selected": (_vm.selectedSeat === seat.id), "taken": (seat.assigned)
          }
        }, [(_vm.selectedSeat === seat.id) ? _c('i', {
          staticClass: "fa fa-check fixCheck"
        }) : _vm._e(), _vm._v(" "), (_vm.showSeatMarks) ? _c('span', {
          staticClass: "seatMark"
        }, [_vm._v(" " + _vm._s(Number(seat.id.split('_')[2])) + " ")]) : _vm._e()])])])
      })], 2)
    }), 0)
  }), 0) : _c('tr', {
    attrs: {
      "id": "classroom-struct"
    }
  }, [_vm._l((_vm.classroomStructure.data), function(wing) {
    return _c('td', {
      key: wing,
      staticClass: "classroom-wing",
      class: {
        "classroom-wing-left-side": (wing.id === 0)
      }
    }, _vm._l((wing.rows), function(row) {
      return _c('tr', {
        key: row,
        staticClass: "classroom-row"
      }, [(row.id.split('_')[0] === '0' && _vm.showSeatMarks) ? _c('div', {
        staticClass: "rowMark"
      }, [_vm._v(" " + _vm._s(Number(row.id.split('_')[1])) + " ")]) : _vm._e(), _vm._v(" "), _vm._l((row.seats), function(seat) {
        return _c('td', {
          key: seat
        }, [_c('button', {
          staticClass: "seatButton",
          on: {
            "click": function($event) {
              return _vm.colorSeat(seat.id)
            }
          }
        }, [_c('div', {
          staticClass: "classroom-seat",
          class: {
            "groupA": seat.exerciseGroup === "A", "groupB": seat.exerciseGroup === "B", "groupC": seat.exerciseGroup === "C", "groupD": seat.exerciseGroup === "D"
          },
          attrs: {
            "id": seat.id
          }
        }, [(_vm.showSeatMarks) ? _c('span', {
          staticClass: "seatMark"
        }, [_vm._v(" " + _vm._s(Number(seat.id.split('_')[2])) + " ")]) : _vm._e(), _vm._v(" "), ((_vm.drawerMode) && (_vm.showExerciseGroups)) ? _c('p', {
          staticClass: "exerciseGroup"
        }, [_vm._v(_vm._s(seat.exerciseGroup))]) : _vm._e()])])])
      })], 2)
    }), 0)
  }), _vm._v(" "), (_vm.customColoring && !_vm.groupEditor) ? _c('td', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('p', {
    staticClass: "selectSeat",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exams.classrooms.selectColors')) + " ")]), _vm._v(" "), _c('ul', {
    staticClass: "colorPicker"
  }, _vm._l((_vm.selectColors), function(color) {
    return _c('li', {
      key: color
    }, [_c('button', {
      staticClass: "colorPickerButton",
      class: {
        "selectedColorButton": _vm.selectedColor === color
      },
      style: ({
        background: color
      }),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectColor(color)
        }
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.customColoring && !_vm.groupEditor) ? _c('td', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('p', {
    staticClass: "selectSeat",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exams.classrooms.selectedSeats')) + " ")]), _vm._v(" "), _c('ul', {
    staticClass: "colorPicker"
  }, [_vm._l((_vm.coloredSeatsPicked), function(seat) {
    return _c('li', {
      key: seat
    }, [_vm._v(_vm._s(seat))])
  }), _vm._v(" "), _c('li', [_vm._v("Total: " + _vm._s(_vm.coloredSeatsCount))])], 2)]) : _vm._e(), _vm._v(" "), (_vm.groupEditor) ? _c('td', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_c('p', {
    staticClass: "selectSeat",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exams.classrooms.selectGroup')) + " ")]), _vm._v(" "), _c('ul', {
    staticClass: "colorPicker"
  }, _vm._l((["A", "B", "C", "D"]), function(group) {
    return _c('li', {
      key: group
    }, [_c('button', {
      staticClass: "colorPickerButton",
      class: {
        "selectedColorButton": _vm.newGroup === group
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.newGroup === group ? _vm.newGroup = "" : _vm.newGroup = group
        }
      }
    }, [_vm._v(_vm._s(group))])])
  }), 0)]) : _vm._e()], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tr', {
    staticClass: "prof-row"
  }, [(_vm.drawerMode && !_vm.customColoring && !_vm.groupEditor) ? _c('button', {
    staticClass: "showHideExecGroups",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleCustomColoring()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.classrooms.customizeColoring')))]) : _vm._e(), _vm._v(" "), (_vm.drawerMode && _vm.customColoring && !_vm.groupEditor) ? _c('button', {
    staticClass: "showHideExecGroups",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleCustomColoring()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.classrooms.turnOffCustomizeColoring')))]) : _vm._e(), _vm._v(" "), (_vm.drawerMode && !_vm.groupEditor && !_vm.customColoring) ? _c('button', {
    staticClass: "showHideExecGroups",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleGroupEditor()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.classrooms.turnOnGroupEditor')))]) : _vm._e(), _vm._v(" "), (_vm.drawerMode && _vm.groupEditor) ? _c('button', {
    staticClass: "showHideExecGroups",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleGroupEditor()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.classrooms.turnOffGroupEditor')))]) : _vm._e()]), _vm._v(" "), (_vm.drawerMode && !_vm.groupEditor) ? _c('tr', {
    staticClass: "colorSettings"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('pages.exams.classrooms.colorGroup')) + "\n      "), _c('button', {
    staticClass: "colorGroup buttonA",
    staticStyle: {
      "background": "green"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.groupColor("groupA")
      }
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('button', {
    staticClass: "colorGroup buttonB",
    staticStyle: {
      "background": "red"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.groupColor("groupB")
      }
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('button', {
    staticClass: "colorGroup buttonC",
    staticStyle: {
      "background": "pink"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.groupColor("groupC")
      }
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('button', {
    staticClass: "colorGroup buttonD",
    staticStyle: {
      "background": "blue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.groupColor("groupD")
      }
    }
  }, [_vm._v("D")])]) : _vm._e()]), _vm._v(" "), (_vm.seated) ? _c('div', {
    attrs: {
      "id": "successfullySeated"
    }
  }, [_c('h4', {
    staticClass: "pageText"
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.exams.classrooms.successfullySeated')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "ready",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.readyStart()
      }
    }
  }, [_vm._v(" START ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "prof-row"
  }, [_c('div', {
    staticClass: "prof"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c2dfaa9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c2dfaa9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/StopCheating.vue
// module id = 1386
// module chunks = 1